import React, { useEffect, useState } from 'react';

const inr = v => Number(v||0).toFixed(2);

export default function PrintDieselReportPage() {
  const [data, setData] = useState(null);

  useEffect(()=>{
    const stored = sessionStorage.getItem('printDieselReport');
    if(stored) {
      setData(JSON.parse(stored));
      setTimeout(()=>window.print(), 1000);
    }
  }, []);

  if(!data) return <div style={{padding:20,fontFamily:'Arial',textAlign:'center',marginTop:40}}>Loading report...</div>;

  const { summary={}, dailyData={}, total=0, sessionCount=0, dieselStock=0, filters={} } = data;

  const MACHINES = [
    { key:'compressor', label:'Compressor (Drilling)',  color:'#1e3a5f' },
    { key:'generator',  label:'Generator (Wire Saw)',   color:'#185FA5' },
    { key:'tipper',     label:'Tipper (Transport)',     color:'#854F0B' },
    { key:'poclain',    label:'Poclain (Transport)',    color:'#3B6D11' },
    { key:'other',      label:'Other Vehicles',         color:'#555'    },
  ];

  const fmt = d => { try{ return new Date(d).toLocaleDateString('en-IN',{day:'numeric',month:'long',year:'numeric'}); }catch{ return d; }};

  return (
    <div style={{fontFamily:'Inter,Arial,sans-serif',fontSize:12,color:'#333',padding:'10mm',maxWidth:'210mm',margin:'0 auto'}}>
      <style>{`
        @media print {
          @page { margin:8mm; size:A4; }
          body { margin:0; }
          tr { page-break-inside:avoid; }
        }
        * { box-sizing:border-box; }
      `}</style>

      {/* Company Header */}
      <div style={{borderBottom:'3px solid #1e3a5f',paddingBottom:10,marginBottom:14,display:'flex',justifyContent:'space-between',alignItems:'flex-start'}}>
        <div style={{display:'flex',alignItems:'center',gap:14}}>
          <img src="/TycheAbodes-logo1.png" alt="Logo" style={{width:52,height:52,objectFit:'contain',borderRadius:6}} onError={e=>e.target.style.display='none'}/>
          <div>
            <div style={{fontSize:17,fontWeight:800,color:'#1e3a5f',fontFamily:'Inter,sans-serif',letterSpacing:0.5}}>TYCHE ABODES PRIVATE LIMITED</div>
            <div style={{fontSize:11,color:'#555',marginTop:2}}>No. 401, Ramani's Frazer Square,</div>
            <div style={{fontSize:11,color:'#555'}}>Near Head Post Office, Goods Shed Road, Coimbatore - 641001.</div>
            <div style={{fontSize:11,color:'#555',marginTop:1}}>📞 +91 94433 23246 &nbsp;|&nbsp; GSTIN: 33AAKCT5967G1ZY</div>
          </div>
        </div>
        <div style={{textAlign:'right',flexShrink:0}}>
          <div style={{fontSize:16,fontWeight:800,color:'#1e3a5f',textTransform:'uppercase',letterSpacing:1}}>Diesel Consumption Report</div>
          <div style={{fontSize:11,color:'#555',marginTop:4}}>Period: <strong>{fmt(filters.from)}</strong> to <strong>{fmt(filters.to)}</strong></div>
          <div style={{fontSize:11,color:'#555'}}>Generated: <strong>{new Date().toLocaleDateString('en-IN')}</strong></div>
        </div>
      </div>

      {/* KPI Summary */}
      <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',border:'1px solid #ddd',borderRadius:6,overflow:'hidden',marginBottom:14}}>
        {[
          ['Total Diesel Used',    `${inr(total)} L`,        '#1e3a5f'],
          ['Sessions in Range',    sessionCount,              '#185FA5'],
          ['Avg per Session',      sessionCount>0?`${inr(total/sessionCount)} L`:'0.00 L', '#854F0B'],
          ['Current Stock',        `${inr(dieselStock)} L`,  '#3B6D11'],
        ].map(([l,v,c],i)=>(
          <div key={i} style={{padding:'8px 12px',textAlign:'center',background:i%2===0?'#f8f9fc':'#fff',borderRight:i<3?'1px solid #ddd':'none'}}>
            <div style={{fontSize:22,fontWeight:700,color:c,fontFamily:'monospace'}}>{v}</div>
            <div style={{fontSize:9,color:'#666',textTransform:'uppercase',letterSpacing:'0.5px',marginTop:2}}>{l}</div>
          </div>
        ))}
      </div>

      {/* Machine-wise Breakdown */}
      <div style={{marginBottom:14}}>
        <div style={{fontSize:11,fontWeight:700,color:'#1e3a5f',textTransform:'uppercase',letterSpacing:'1px',borderBottom:'2px solid #1e3a5f',paddingBottom:4,marginBottom:8}}>Machine-wise Breakdown</div>
        <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
          <thead>
            <tr style={{background:'#1e3a5f',color:'#fff'}}>
              <th style={{padding:'6px 10px',textAlign:'left'}}>Machine / Category</th>
              <th style={{padding:'6px 10px',textAlign:'center'}}>Sessions</th>
              <th style={{padding:'6px 10px',textAlign:'right'}}>Total Litres</th>
              <th style={{padding:'6px 10px',textAlign:'right'}}>% of Total</th>
              <th style={{padding:'6px 10px',textAlign:'left'}}>Usage</th>
            </tr>
          </thead>
          <tbody>
            {MACHINES.filter(m=>summary[m.key]?.litres>0).map((m,i)=>{
              const val = summary[m.key]||{litres:0,sessions:0};
              const pct = total>0?(val.litres/total*100).toFixed(1):0;
              return (
                <tr key={i} style={{background:i%2===0?'#f8f9fc':'#fff',borderBottom:'1px solid #eee'}}>
                  <td style={{padding:'5px 10px',fontWeight:600,color:m.color}}>{m.label}</td>
                  <td style={{padding:'5px 10px',fontFamily:'monospace',textAlign:'center'}}>{val.sessions}</td>
                  <td style={{padding:'5px 10px',fontFamily:'monospace',fontWeight:700,color:m.color,textAlign:'right'}}>{inr(val.litres)} L</td>
                  <td style={{padding:'5px 10px',fontFamily:'monospace',textAlign:'right'}}>{pct}%</td>
                  <td style={{padding:'5px 10px',minWidth:100}}>
                    <div style={{background:'#eee',borderRadius:4,height:8,overflow:'hidden'}}>
                      <div style={{width:`${pct}%`,height:'100%',background:m.color,borderRadius:4}}/>
                    </div>
                  </td>
                </tr>
              );
            })}
            <tr style={{background:'#1e3a5f',color:'#fff',fontWeight:700}}>
              <td style={{padding:'6px 10px'}}>TOTAL</td>
              <td style={{padding:'6px 10px',textAlign:'center',fontFamily:'monospace'}}>{Object.values(summary).reduce((s,v)=>s+(v.sessions||0),0)}</td>
              <td style={{padding:'6px 10px',textAlign:'right',fontFamily:'monospace'}}>{inr(total)} L</td>
              <td style={{padding:'6px 10px',textAlign:'right'}}>100%</td>
              <td/>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Daily Breakdown */}
      {Object.keys(dailyData).length > 0 && (
        <div>
          <div style={{fontSize:11,fontWeight:700,color:'#1e3a5f',textTransform:'uppercase',letterSpacing:'1px',borderBottom:'2px solid #1e3a5f',paddingBottom:4,marginBottom:8}}>Daily Breakdown</div>
          <table style={{width:'100%',borderCollapse:'collapse',fontSize:11}}>
            <thead>
              <tr style={{background:'#1e3a5f',color:'#fff'}}>
                <th style={{padding:'5px 8px',textAlign:'left'}}>Date</th>
                <th style={{padding:'5px 8px',textAlign:'right'}}>Compressor</th>
                <th style={{padding:'5px 8px',textAlign:'right'}}>Generator</th>
                <th style={{padding:'5px 8px',textAlign:'right'}}>Tipper</th>
                <th style={{padding:'5px 8px',textAlign:'right'}}>Poclain</th>
                <th style={{padding:'5px 8px',textAlign:'right'}}>Other</th>
                <th style={{padding:'5px 8px',textAlign:'right'}}>Daily Total</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(dailyData).sort().map(([date,d],i)=>{
                const dayTotal = Object.values(d).reduce((s,v)=>s+v,0);
                return (
                  <tr key={i} style={{background:i%2===0?'#f8f9fc':'#fff',borderBottom:'1px solid #eee'}}>
                    <td style={{padding:'4px 8px',fontFamily:'monospace',fontWeight:600,color:'#1e3a5f'}}>{date}</td>
                    <td style={{padding:'4px 8px',fontFamily:'monospace',textAlign:'right',color:'#1e3a5f'}}>{d.compressor>0?`${inr(d.compressor)} L`:'—'}</td>
                    <td style={{padding:'4px 8px',fontFamily:'monospace',textAlign:'right',color:'#185FA5'}}>{d.generator>0?`${inr(d.generator)} L`:'—'}</td>
                    <td style={{padding:'4px 8px',fontFamily:'monospace',textAlign:'right',color:'#854F0B'}}>{d.tipper>0?`${inr(d.tipper)} L`:'—'}</td>
                    <td style={{padding:'4px 8px',fontFamily:'monospace',textAlign:'right',color:'#3B6D11'}}>{d.poclain>0?`${inr(d.poclain)} L`:'—'}</td>
                    <td style={{padding:'4px 8px',fontFamily:'monospace',textAlign:'right',color:'#555'}}>{d.other>0?`${inr(d.other)} L`:'—'}</td>
                    <td style={{padding:'4px 8px',fontFamily:'monospace',fontWeight:700,color:'#1e3a5f',textAlign:'right'}}>{inr(dayTotal)} L</td>
                  </tr>
                );
              })}
              <tr style={{background:'#1e3a5f',color:'#fff',fontWeight:700}}>
                <td style={{padding:'6px 8px'}}>TOTAL</td>
                <td colSpan={5}/>
                <td style={{padding:'6px 8px',fontFamily:'monospace',textAlign:'right'}}>{inr(total)} L</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {/* Footer */}
      <div style={{borderTop:'2px solid #1e3a5f',paddingTop:8,marginTop:14,display:'flex',justifyContent:'space-between',fontSize:10,color:'#666'}}>
        <span>TYCHE ABODES PRIVATE LIMITED — Confidential</span>
        <span>Generated: {new Date().toLocaleString('en-IN')}</span>
      </div>
    </div>
  );
}